import axios from 'axios'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

const CLUB_ADD_URL = 'admin/auth/clubs/add'

function ClubRegister() {

  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const token = localStorage.getItem('token')
  let navigate = useNavigate()

  const submitHandler = (e) => {
    if (name && email && password) {
      e.preventDefault();
      let data = { name, email, password }
      axios.post(`${process.env.REACT_APP_DEPT_API}/${CLUB_ADD_URL}`, data, {
        headers: {
          authorization: `Bearer ${token}`
        }
      }).then(() => {
        alert("Registered sucessfully")
      }).then(() => {
        navigate('/admin/clubs')
      }).catch(err => {
        alert(err.response.data.error)
        console.log(err)
      })
    } else {
      alert('Enter all the fields!')
    }
  }

  return (
    <div className='admin'>
      <div className='section__container'>
        <div className='section'>
          <h3 className='section__header'>Register Club</h3>
          <form onSubmit={submitHandler} className="admin_form_container">
            <div className='admin_input_container'>
              <label className='admin_label'>Name</label>
              <input className='admin_input' type="text" placeholder='Jane Doe' value={name} onChange={e => setName(e.target.value)} />
            </div>
            <div className='admin_input_container'>
              <label className='admin_label'>Email</label>
              <input className='admin_input' type="email" placeholder='example@gmail.com' value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div className='admin_input_container'>
              <label className='admin_label'>Password</label>
              <input className='admin_input' type="password" placeholder='*******' value={password} onChange={e => setPassword(e.target.value)} />
            </div>
            <button type="submit" className='admin_btn'>Submit</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default ClubRegister